import { render, staticRenderFns } from "./SyllabusSections.vue?vue&type=template&id=6604da8f&"
import script from "./SyllabusSections.vue?vue&type=script&lang=js&"
export * from "./SyllabusSections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports